"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ImageContext = _interopRequireDefault(require("../style/ImageContext.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * ImageContext component
 */
var ImageContext = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageContext, _React$Component);

  var _super = _createSuper(ImageContext);

  function ImageContext() {
    _classCallCheck(this, ImageContext);

    return _super.apply(this, arguments);
  }

  _createClass(ImageContext, [{
    key: "render",

    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */
    value: function render() {
      var _this$props = this.props,
          imageData = _this$props.imageData,
          width = _this$props.width,
          height = _this$props.height;

      if (!imageData) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: _ImageContext.default.component
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "preview-text"
      }, /*#__PURE__*/_react.default.createElement("b", null, "Image Preview:")), /*#__PURE__*/_react.default.createElement("span", {
        className: "img-container"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: imageData,
        id: "image-preview",
        width: width,
        height: height
      })));
    }
  }]);

  return ImageContext;
}(_react.default.Component);

exports.default = ImageContext;
ImageContext.propTypes = {
  imageData: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number
};